import { render, staticRenderFns } from "./CreateContractModal.vue?vue&type=template&id=489d4f0a&scoped=true&"
import script from "./CreateContractModal.vue?vue&type=script&lang=js&"
export * from "./CreateContractModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateContractModal.vue?vue&type=style&index=0&id=489d4f0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489d4f0a",
  null
  
)

export default component.exports